/**
 * TutorSpace — entry point for the tutor role space.
 * Hosts AppShell with tutor lateral navigation.
 * Feature pages (notes grid, calendar) land here in Parts 2–3.
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import AppShell from '../../components/layout/AppShell';
import GradesPage from './GradesPage';
import CalendarPage from './CalendarPage';

const TutorSpace = () => {
  return (
    <AppShell role="tutor">
      <Routes>
        <Route index element={<Navigate to="notes" replace />} />
        <Route path="notes" element={<GradesPage />} />
        <Route path="calendrier" element={<CalendarPage />} />
      </Routes>
    </AppShell>
  );
};

export default TutorSpace;
